export const SOLID_COLOR_CLASS = `is-style-solid-color`;
//# sourceMappingURL=shared.js.map